const SHOW_LOADING = '@loading/show-loading';
const SHOW_LOADING_TABLE = '@loading/show-loading-table';
const SHOW_LOADING_BUTTON = '@loading/show-loading-button';
const DISMISS_LOADING = '@loading/dismiss-loading';
const DISMISS_LOADING_TABLE = '@loading/dismiss-loading-table';
const DISMISS_LOADING_BUTTON = '@loading/dismiss-loading-button';

export {
  SHOW_LOADING,
  DISMISS_LOADING,
  SHOW_LOADING_TABLE,
  DISMISS_LOADING_TABLE,
  SHOW_LOADING_BUTTON,
  DISMISS_LOADING_BUTTON,
};
